
import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import WxLocation from '@/components/WX/WxLocation.vue';

declare const BMap: any;

@Component({
    components: {
        WxLocation,
    },
})
export default class BaiMap extends Vue {
  public $api: any;
  public longitude: number = 0; // 精度
  public latitude: number = 0; // 维度
  
  public getLocation(event: any) {
    const that = this;
    that.longitude = event.longitude;
    that.latitude = event.latitude;
    const geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition((r: any) => {
        // 关于状态码
        // BMAP_STATUS_SUCCESS	检索成功。对应数值“0”。
        // BMAP_STATUS_CITY_LIST	城市列表。对应数值“1”。
        // BMAP_STATUS_UNKNOWN_LOCATION	位置结果未知。对应数值“2”。
        // BMAP_STATUS_UNKNOWN_ROUTE	导航结果未知。对应数值“3”。
        // BMAP_STATUS_INVALID_KEY	非法密钥。对应数值“4”。
        // BMAP_STATUS_INVALID_REQUEST	非法请求。对应数值“5”。
        // BMAP_STATUS_PERMISSION_DENIED	没有权限。对应数值“6”。(自 1.1 新增)
        // BMAP_STATUS_SERVICE_UNAVAILABLE	服务不可用。对应数值“7”。(自 1.1 新增)
        // BMAP_STATUS_TIMEOUT	超时。对应数值“8”。(自 1.1 新增)
        if (geolocation.getStatus() !== 0 && geolocation.getStatus() !== 1) {
            that.$emit('error', {
                msg: '地址获取失败',
            });
            return;
        }
        const ggPoint = new BMap.Point(that.longitude, that.latitude);
        const convertor = new BMap.Convertor();
        const geoc = new BMap.Geocoder();
        const pointArr = [];
        pointArr.push(ggPoint);
        convertor.translate(pointArr, 1, 5, (data: any) => {
            geoc.getLocation(data.points[0], (rs: any) => {
                if (!rs || !rs.surroundingPois.length) {
                    that.$emit('error', {
                        msg: '地址获取失败',
                    });
                    return;
                }
                that.$emit('init', {
                    longitude: rs.point.lng,
                    latitude: rs.point.lat,
                    location: rs.address,
                    address: rs.surroundingPois,
                    addressComponent: rs.addressComponent,
                });
            });
        });
    });
  }

  public getError(err: any) {
    this.$emit('error', {
        msg: err.msg,
    });
    this.getLocationBySDK();
  }

  // 手机GPS定位
  public getLocationByGPS() {
    const that = this;
    const options = {
        enableHighAccuracy : true,
        maximumAge : 1000,
    };
    if (navigator.geolocation) {
        // 浏览器支持geolocation
        navigator.geolocation.getCurrentPosition((position: any) => {
            // 经度
            that.longitude = position.coords.longitude;
            // 纬度
            that.latitude = position.coords.latitude;
            const point = new BMap.Point(position.coords.longitude, position.coords.latitude);
            const gc = new BMap.Geocoder();
            gc.getLocation(point, (rs: any) => {
                that.$emit('init', {
                    longitude: point.longitude,
                    latitude: point.latitude,
                    location: rs.address,
                    address: rs.surroundingPois,
                    addressComponent: rs.addressComponent,
                });
            });
        }, (error: any) => {
            let errormsg;
            switch (error.code) {
            case 1:
                errormsg = '位置服务被拒绝，请点击刷新重试！';
                break;
            case 2:
                errormsg = '暂时获取不到位置信息，请点击刷新重试！';
                break;
            case 3:
                errormsg = '获取信息超时，请点击刷新重试！';
                break;
            case 4:
                errormsg = '未知错误，请点击刷新重试！';
                break;
            }
            that.$emit('error', {
                msg: errormsg,
            });
        }, options);
    } else {
        // 浏览器不支持geolocation
        that.$emit('error', {
            msg: '您的浏览器不支持地理位置定位',
        });
    }
  }

  // 通过百度sdk定位
  public getLocationBySDK() {
    const that = this;
    // 微信配置失败后使用百度地图sdk获取用户大概坐标
    const geolocation = new BMap.Geolocation();
    const gc = new BMap.Geocoder(); // 创建地理编码器
    // 开启SDK辅助定位
    geolocation.enableSDKLocation();
    geolocation.getCurrentPosition((r: any) => {
        if (geolocation.getStatus() === 0) {
            that.longitude = r.point.lng;
            that.latitude = r.point.lat;

            const pt = r.point;   
 
            gc.getLocation(pt, (rs: any) => {    
                that.$emit('init', {
                    longitude: that.longitude,
                    latitude: that.latitude,
                    location: rs.address,
                    address: rs.surroundingPois,
                    addressComponent: rs.addressComponent,
                });
            });  
        } else {
            that.$emit('error', {
                msg: '地址获取失败',
            });
        }        
    });
  }
  
  public getLocationByHttp(event: any) {
    this.longitude = event.longitude;
    this.latitude = event.latitude;
    // 使用http请求获得
    this.$api.handleGetToken('http://api.map.baidu.com/geoconv/v1/', {
        coords: event.latitude + ',' + event.longitude,
        from: 3,
        to: 5,
        ak: 'C088dc15fbc94dd38fe75819df4a7059',
    }, (res: any) => {
        this.getAddressByHttp(res.result[0]);
    }, (err: any) => {
        this.$emit('error', {
            msg: '经纬度修正失败',
        });
    });
  }

  public getAddressByHttp(event: any) {
    this.$api.handleGetToken('http://api.map.baidu.com/geocoder/v2/', {
        location: event.x + ',' + event.y,
        output: 'json',
        pois: 1,
        ak: 'C088dc15fbc94dd38fe75819df4a7059',
    }, (res: any) => {
        this.$emit('init', {
            longitude: this.longitude,
            latitude: this.latitude,
            location: res.result.formatted_address,
            address: res.result.pois,
            addressComponent: res.result.addressComponent,
        });
    }, (err: any) => {
        this.$emit('error', {
            msg: '位置信息获取失败',
        });
    });
  }
}
